import i18next from "i18next";
import { useState, useEffect } from "react";

const useTimeLeft = (
  endDate: { seconds: number; nanoseconds: number },
  startDate?: { seconds: number; nanoseconds: number }
) => {
  const [timeLeft, setTimeLeft] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const endInMilliseconds =
        endDate.seconds * 1000 + endDate.nanoseconds / 1000000;
      let distance = endInMilliseconds - now;
      let statusKey = "challenge.status.ongoing";

      if (startDate) {
        const startInMilliseconds =
          startDate.seconds * 1000 + startDate.nanoseconds / 1000000;
        if (now < startInMilliseconds) {
          distance = startInMilliseconds - now;
          statusKey = "challenge.status.starting";
        }
      }

      if (distance < 0) {
        clearInterval(interval);
        setTimeLeft(i18next.t("challenge.status.ended"));
        setLoading(false);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      let timeString = "";
      if (days > 0) {
        timeString += `${days}${i18next.t("challenge.counter.days")} `;
      }
      if (hours > 0 || days > 0) {
        timeString += `${hours}${i18next.t("challenge.counter.hours")} `;
      }
      if (minutes > 0 || hours > 0 || days > 0) {
        timeString += `${minutes}${i18next.t("challenge.counter.minutes")} `;
      }
      timeString += `${seconds}${i18next.t("challenge.counter.seconds")}`;

      setTimeLeft(`${i18next.t(statusKey)} ${timeString}`);
      setLoading(false);
    }, 1000);

    return () => clearInterval(interval);
  }, [endDate, startDate]);

  return { timeLeft, loading };
};

export default useTimeLeft;
